import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box, Input } from '~Styles';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useI18n } from '~Hooks';
import ArrowRangeIcon from '~Assets/icons/arrow_range.svg';
import Icon from '~ComponentsImproved/Icon';

/** Min/max inputs share the row equally and fill the full width */
const RangeInput = styled(Input)`
  flex: 1;
  min-width: 0;
`;

interface Props {
  label: string;
  minValue: string;
  maxValue: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
}

/** A labelled min/max input pair for a currency range filter */
const RangeFilter: FC<Props> = ({ label, minValue, maxValue, onMinChange, onMaxChange }) => {
  const { i18n } = useI18n();

  return (
    <Box display="flex" flexDirection="column" gap="xs">
      <Heading level={7} color="var(--colorBlueGray200)" bottom={0}>
        {label}
      </Heading>
      <Box display="flex" alignItems="center" gap="xs" fluid>
        <RangeInput
          dark
          type="number"
          value={minValue}
          placeholder={i18n('General.Min')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onMinChange(e.target.value)}
        />

        <Icon src={ArrowRangeIcon} color="var(--colorBlueGray800)" height="16px" width="16px" />

        <RangeInput
          dark
          type="number"
          value={maxValue}
          placeholder={i18n('General.Max')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onMaxChange(e.target.value)}
        />
      </Box>
    </Box>
  );
};

export default RangeFilter;
